// Add your custom JS here.

(function ($) {

	$(function () {

		let thumb_slider_direction = '';
		let winw = $(window).width();

		if (winw > 767) {
			thumb_slider_direction = "vertical";
		} else {
			thumb_slider_direction = "horizontal";
		}

		// $("#thumbnail-slider").flexslider({
		// 	animation: "slide",
		// 	controlNav: false,
		// 	animationLoop: false,
		// 	slideshow: false,
		// 	itemWidth: 210,
		// 	itemMargin: 15,
		// 	direction: thumb_slider_direction,
		// 	asNavFor: "#slider",
		// 	itemWidth: 150,
		// 	itemMargin: 0,
		// });

		// $("#slider").flexslider({
		// 	animation: "slide",
		// 	controlNav: false,
		// 	animationLoop: false,
		// 	slideshow: false,
		// 	sync: "#thumbnail-slider",
		// 	smoothHeight: true,
		// });

		$('body').on('click', '.js-updqty-plus', function () {
			let input = $(this).parent().find('.js-updqty-input');
			var maxValue = parseInt($(input).attr('max'));
			if (maxValue) {
				var inputValue = $(input).val();
				if (inputValue < maxValue) {
					$(input).val(parseInt(inputValue) + 1);
				}
			} else {
				var inputValue = $(input).val();
				$(input).val(parseInt(inputValue) + 1);
			}
			$('.woocommerce-cart').find('button[name="update_cart"]').prop('disabled', false).trigger("click");
			// $("[name='update_cart']").trigger("click");

			let winw = $(window).width();
			if (winw < 768) {
				$('.js-myloader').fadeIn();
				// $('.js-myloader-total').fadeIn();
			}
		});

		$('body').on('click', '.js-updqty-minus', function () {
			let input = $(this).parent().find('.js-updqty-input');
			let hasMin = $(input).attr('min');
			if (hasMin) {
				let min = parseInt(hasMin);
				var inputValue = $(input).val();
				if (inputValue > min) {
					$(input).val(parseInt(inputValue) - 1);
				}
			} else {
				var inputValue = $(input).val();
				if (inputValue > 0) {
					$(input).val(parseInt(inputValue) - 1);

				}
			}

			if ($(input).val() == 0) {
				let st_1 = setTimeout(() => {
					window.location.reload();
					clearTimeout(st_1);
				}, 1000);
			}
			$('.woocommerce-cart').find('button[name="update_cart"]').prop('disabled', false).trigger("click");
			// $("[name='update_cart']").trigger("click");

			let winw = $(window).width();
			if (winw < 768) {
				$('.js-myloader').fadeIn();
				// $('.js-myloader-total').fadeIn();
			}
		});

		$('body').on('click', '.js-mob-remove-qty', function () {
			$('.js-myloader').fadeIn();
			// $('.js-myloader-total').fadeIn();
		});

		function adjust_vertical_slider_thumbs_height(no_of_t = 5) {
			let thumb_sldr = $('.js-thumb-slider');
			let main_sldr = $('.js-main-slider');
			let main_img = $('.js-main-slider .swiper-slide-active img');
			let thumb_slider_items = $('.js-thumb-slider .swiper-slide');
			let slidesPerView = no_of_t;
			let calc = main_img.height() / slidesPerView;
			$(thumb_slider_items).css('min-height', calc + 'px');
			$(thumb_slider_items).css('max-height', calc + 'px');
			thumb_sldr.css('max-height', main_img.height() + 'px');
		}

		let thumb_swiper = new Swiper('.js-thumb-slider', {
			slidesPerView: 5,
			direction: 'vertical',
			// freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				0: {
					direction: 'horizontal',
				},
				768: {
					direction: 'vertical',
				}
			},
			on: {
				init: function () {
					let winw = $(window).width();
					if (winw > 767) {
						let st = setTimeout(() => {
							adjust_vertical_slider_thumbs_height(5);
							clearTimeout(st);
						}, 500);
					}
				},
			},
		});

		let main_swiper = new Swiper('.js-main-slider', {
			thumbs: {
				swiper: thumb_swiper,
			},
			// beforeResize: function () {
			// 	let st = setTimeout(()=>{
			// 		adjust_vertical_slider_thumbs_height();
			// 		clearTimeout(st);
			// 	}, 500);
			// },
			on: {
				slideChange: function () {
					let winw = $(window).width();
					if (winw > 767) {
						let st = setTimeout(() => {
							adjust_vertical_slider_thumbs_height(5);
							clearTimeout(st);
						}, 500);
					}
				},
			},
		});

		$(window).on('resize', function () {
			let winw = $(window).width();
			if (winw > 767) {
				let st = setTimeout(() => {
					adjust_vertical_slider_thumbs_height(5);
					clearTimeout(st);
				}, 500);
			}
		});

		$('.js-chbadrchk').on('change', function () {
			let ship_f = $("#ship_form");
			let bill_f = $("#bill_form");

			// Find inputs
			let sh_fnm = ship_f.find("[name='billing_first_name']");
			let bl_fnm = bill_f.find("[name='shipping_first_name']");

			let sh_lnm = ship_f.find("[name='billing_last_name']");
			let bl_lnm = bill_f.find("[name='shipping_last_name']");

			let sh_cmp = ship_f.find("[name='billing_company']");
			let bl_cmp = bill_f.find("[name='shipping_company']");

			let sh_bladr1 = ship_f.find("[name='billing_address_1']");
			let bl_bladr1 = bill_f.find("[name='shipping_address_1']");

			let sh_bladr2 = ship_f.find("[name='billing_address_2']");
			let bl_bladr2 = bill_f.find("[name='shipping_address_2']");

			let sh_blcty = ship_f.find("[name='billing_city']");
			let bl_blcty = bill_f.find("[name='shipping_city']");

			let sh_pncd = ship_f.find("[name='billing_postcode']");
			let bl_pncd = bill_f.find("[name='shipping_postcode']");

			let isChecked = $(this).prop("checked");
			if (isChecked) {
				$(bl_fnm).val($(sh_fnm).val());
				$(bl_lnm).val($(sh_lnm).val());
				$(bl_cmp).val($(sh_cmp).val());
				$(bl_bladr1).val($(sh_bladr1).val());
				$(bl_bladr2).val($(sh_bladr2).val());
				$(bl_blcty).val($(sh_blcty).val());
				$(bl_pncd).val($(sh_pncd).val());
			} else {
				$(bl_fnm).val('');
				$(bl_lnm).val('');
				$(bl_cmp).val('');
				$(bl_bladr1).val('');
				$(bl_bladr2).val('');
				$(bl_blcty).val('');
				$(bl_pncd).val('');
			}
		});

		$('.js-cart-contbox .btn-outline-primary').on('click', function (e) {
			e.preventDefault();
			let $thisbutton = $(this),
				$form = $thisbutton.closest('form.cart'),
				id = $thisbutton.val(),
				product_qty = $form.find('input[name=quantity]').val() || 1,
				product_id = $form.find('input[name=product_id]').val() || id,
				variation_id = $form.find('input[name=variation_id]').val() || 0;
			var data = {
				action: 'ql_woocommerce_ajax_add_to_cart',
				product_id: product_id,
				product_sku: '',
				quantity: product_qty,
				variation_id: variation_id,
			};
			$.ajax({
				type: 'post',
				url: wc_add_to_cart_params.ajax_url,
				data: data,
				beforeSend: function (response) {
					$thisbutton.removeClass('added').addClass('loading');
				},
				complete: function (response) {
					$thisbutton.addClass('added').removeClass('loading');
				},
				success: function (response) {
					if (response.error & response.product_url) {
						window.location = response.product_url;
						return;
					} else {
						//$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
					}
				},
			});
			$(this).text("Added to Cart");
			$(this).addClass('active');
			let st_1 = setTimeout(() => {
				$(this).text("Add to Cart");
				$(this).removeClass('active');
				clearTimeout(st_1);
			}, 3000);

			// Activate Cart - turns green.
			let cartlm = $("#cartmlink");
			if (!cartlm.hasClass('active')) {
				cartlm.addClass('active');
			}

			// Update cart item
			let qtyinp = $("[name='quantity']");
			let crtm = $("#cart-mcount");
			let numcr = crtm.text() == '0' ? crtm.text(qtyinp.val()) : parseInt(crtm.text()) + parseInt(qtyinp.val());
			crtm.text(numcr);
		});

	}); // End of DOM.Ready();

})(jQuery);